import { memo, useCallback } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { MenuItem } from '@aimsos/ui';

/**
 * One option of the record-type rail: icon, label and, when known, how many
 * records the type has. The click handler is built here from `id` so the page
 * can hand every row the same stable `onSelect` and `MenuItem`'s memo holds.
 */
const RecordTypeRailItem = memo(function RecordTypeRailItem({
  id,
  label,
  count,
  icon,
  selected,
  onSelect,
}) {
  const { t } = useTranslation('unified-profiles');

  const handleClick = useCallback(() => onSelect(id), [onSelect, id]);

  // A zero is a real count; only a missing one is left out.
  const description = typeof count === 'number' ? t('list.types.recordCount', { count }) : undefined;

  return (
    <MenuItem
      role="option"
      label={label}
      description={description}
      subtextMenu={Boolean(description)}
      highlightIcon={icon}
      selected={selected}
      onClick={handleClick}
      // `MenuItem` is `w-full min-w-[16.25rem]`. Stacked above the results (below
      // `lg`) every option must be a fixed-width chip in a scrolling row instead
      // of one full-width block each; in the 200px column it fills the column.
      className="!w-auto !min-w-[168px] shrink-0 lg:!w-full lg:!min-w-0"
    />
  );
});

export default RecordTypeRailItem;
